import {on, findAll, hasClass, addClass, removeClass} from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";
import Collapse from 'bootstrap/js/dist/collapse';

export function init () {
    onFind('.js-collapse-all', function (item) {
        on('click', function(event) {
            let show = hasClass('is-collapsed', item);
            findAll(item.getAttribute('data-collapse-target')).map((collapseItem) => {
                let collapseInstance = Collapse.getOrCreateInstance(collapseItem, {toggle: false});

                if (collapseInstance) {
                    if (show){
                        console.log('show all ?')
                        collapseInstance.show();
                    } else {
                        collapseInstance.hide();
                    }
                }
            })

            if (show){
                removeClass('is-collapsed', item);
            } else {
                addClass('is-collapsed', item);
            }
        }, item);
    });
}